import {request,download} from '@/utils/request'

// 仓库列表
export function getWarehouse(data) {
  return request('GET','/admin/warehouse/page', data, true)
}
// 仓库同步
export function postWarehouse(data) {
  return request('POST','/admin/warehouse/sync', data, true)
}
// 仓库详情
export function getWarehouseDetail(id) {
  return request('GET','/admin/warehouse/'+id, '', true)
}
// 理赔列表
export function getClaim(data) {
  return request('GET','/admin/claim/page', data, true)
}
// 理赔审核
export function postClaim(data) {
  return request('POST','/admin/claim/audit', data, true)
}
// 理赔详情
export function getClaimDetail(id) {
  return request('GET','/admin/claim/'+id, '', true)
}

// 水卡列表
export function getCard(data) {
  return request('GET','/admin/card/page', data, true)
}
// 新增水卡
export function postCard(data) {
  return request('POST','/admin/card', data, true)
}
// 批量新增水卡
export function postCardBatch(data) {
  return request('POST','/admin/order/batch', data, true)
}
// 批量激活水卡
export function postCardUpBatch(data) {
  return request('POST','/admin/order/updatebatch', data, true)
}
// 删除水卡
export function delCard(id) {
  return request('DELETE','/admin/card/'+id, '', true)
}
// 水卡规格列表
export function getCardList(data) {
  return request('POST','/admin/card/list', data, true)
}
// 订单列表
export function getOrder(data) {
  return request('GET','/admin/order/page', data, true)
}
// 新增订单列表
export function getOrderAdd(data) {
  return request('GET','/admin/order/add/page', data, true)
}
// 删除水卡
export function delOrder(id) {
  return request('DELETE','/admin/order/'+id, '', true)
}
// 订单详情
export function getOrderDetail(id) {
  return request('GET','/admin/order/'+id, '', true)
}
// 导入水卡
export function postOrder(data) {
  return request('POST','/admin/order', data, true)
}

// // 导入水卡组
// export function postTemplate(data) {
//   return request('POST','/admin/order/template', data, true)
// }
// 导入水卡组
export function postTemplate() {
  return '/admin/order/template'
}


// 下载模板
export function getTemplate(data) {
  return download('GET','/admin/order/downTemplate', data , '水卡模板')
}
// 批量导出
export function getExport(data) {
  return download('GET','/admin/order/export-excel', data , '导出水卡')
}

// 用户列表
export function getUser(data) {
  return request('GET','/admin/applet/user/page', data, true)
}
// 修改订单密码
export function postPwd(data) {
  return request('POST','/admin/order/pwd/change', data, true)
}

// 延期
export function postDelay(data) {
  return request('POST','/admin/order/delay', data, true)
}
// 省列表
export function getPro(data) {
  return request('GET','/common/area/provide', data, true)
}
// 获得自有仓配送列表
export function getSelf(data) {
  return request('GET','/admin/order/self/page', data, true)
}
// 获得配送列表
export function getDelivery(data) {
  return request('GET','/admin/order/delivery/page', data, true)
}

// 删除订单（新）
export function postorderDel(data) {
  return request('POST','/admin/order/deleteBatch', data, true)
}
// 批量确认订单
export function postConfirm(data) {
  return request('POST','/admin/order/self/confirm/batch', data, true)
}
// 修改token
export function postParam(data) {
  return request('POST','/admin/param', data, true)
}
// 查看token
export function getParam(data) {
  return request('GET','/admin/param/', data, true)
}
// 获得问答列表
export function getFaq(data) {
  return request('GET','/admin/faq/page', data, true)
}
// 获得问答详情
export function getFaqDetail(id) {
  return request('GET','/admin/faq/'+id, '', true)
}
// 添加问答
export function postFaq(data) {
  return request('POST','/admin/faq', data, true)
}
// 删除问答
export function delFaq(id) {
  return request('DELETE','/admin/faq/'+id, '', true)
}
// 获得新增的用户统计列表
export function getUserOrder(data) {
  return request('GET','/admin/order/user/order/page', data, true)
}
// 批量导出
export function getExportOrder(data) {
  return download('GET','/admin/order/user/order/export-excel', data , '导出订单')
}
// 获得角色列表
export function getSysrole(data) {
  return request('GET','/sys-role/page', data, true)
}
// 获得角色列表
export function getSysroleList(data) {
  return request('GET','/sys-role/list', data, true)
}
// 创建角色
export function postSysrole(data) {
  return request('POST','/sys-role', data, true)
}
// 修改角色
export function putSysrole(data) {
  return request('PUT','/sys-role', data, true)
}
// 删除角色
export function delSysRole(id) {
  return request('DELETE','/sys-role/'+id, '', true)
}
// 获得管理员列表
export function getAdminuser(data) {
  return request('GET','/admin/user/page', data, true)
}
// 获得用户详情
export function getAdminuserOne(id) {
  return request('GET','/admin/user/detail/'+id, '', true)
}
// 新增用户
export function postAdminuser(data) {
  return request('POST','/admin/user', data, true)
}
// 修改密码
export function postPassword(data) {
  return request('POST','/admin/user/password', data, true)
}
// 修改用户
export function putAdminuser(data) {
  return request('PUT','/admin/user', data, true)
}
// 删除用户
export function delAdminuser(id) {
  return request('DELETE','/admin/user/'+id, '', true)
}